// extracted by mini-css-extract-plugin
var _1 = "ColorPicker_buttons__50fc7";
export { _1 as "buttons" }
